<template>
  <ezine-campaigns-settings v-if="campaignId" :campaign-id="campaignId" @change-campaign="campaignId = $event" />
  <ezine-campaigns-index v-else @change-campaign="campaignId = $event" />
</template>

<script>
import EzineCampaignsIndex from './EzineCampaignsIndex.vue'
import EzineCampaignsSettings from './EzineCampaignsSettings.vue'

export default {
  components: {
    EzineCampaignsIndex,
    EzineCampaignsSettings
  },
  data () {
    return {
      campaignId: null
    }
  }
}
</script>
